module.exports = __webpack_public_path__ + "static/media/7digital.9a9498d2.svg";